export const CONTENT = "/content";

export const PREPARATION_ROUTE = CONTENT + "/preparation";
// make routes depend on parent routes so if we changed the parent route, we would change the child route as well
export const VALUES_ROUTE = PREPARATION_ROUTE + "/values";
export const PURPOSES_ROUTE = PREPARATION_ROUTE + "/purposes";
export const VISIONS_ROUTE = PREPARATION_ROUTE + "/visions";
export const MISSIONS_ROUTE = PREPARATION_ROUTE + "/missions";
export const SALPLAN_ROUTE = PREPARATION_ROUTE + "/salplan";
export const SALPLAN_ROUTE_DETAILS = SALPLAN_ROUTE + "/:id";
export const FOCUS_POSTER_ROUTE = PREPARATION_ROUTE + "/focus";
export const FOCUS_POSTER_ROUTE_DETAILS = FOCUS_POSTER_ROUTE + "/:id";

export const AFFIRMATION_ROUTE = CONTENT + "/affirmation";
export const INTENTION_ROUTE = AFFIRMATION_ROUTE + "/sendingintention";
export const CREATEPOSSIBILITY_ROUTE = AFFIRMATION_ROUTE + "/createpossibility";
export const SUBLIMINAL_ROUTE = AFFIRMATION_ROUTE + "/subliminal";
export const SUBLIMINAL_AUDIO_ROUTE = SUBLIMINAL_ROUTE + "/audio/:id";
export const STORY_ROUTE = CREATEPOSSIBILITY_ROUTE + "/story";
export const MAGIC_ROUTE = CREATEPOSSIBILITY_ROUTE + "/magic";
export const PROBLEM_ROUTE = CREATEPOSSIBILITY_ROUTE + "/problem";
export const CLEAR_AND_PROTECT_ROUTE = AFFIRMATION_ROUTE + "/clearandprotect";
export const AREA_ROUTE = CLEAR_AND_PROTECT_ROUTE + "/area";
export const PERSONAL_ROUTE = CLEAR_AND_PROTECT_ROUTE + "/personal";

//Communications Routes
export const COMMUNICATION_ROUTE = CONTENT + "/communication";
export const HEALING_ROUTE = COMMUNICATION_ROUTE + "/healingguide";
export const TAPPING_ROUTE = HEALING_ROUTE + "/tapping";
export const NINE_G_ROUTE = HEALING_ROUTE + "/9g";
export const DISEASE_ROUTE = COMMUNICATION_ROUTE + "/symptoms";
export const PARTS_ROUTE = DISEASE_ROUTE + "/:gender";
export const INNER_ROUTE = PARTS_ROUTE + "/:section";
export const DETAIL_ROUTE = INNER_ROUTE + "/:organ";
export const SESSION_ROUTE = COMMUNICATION_ROUTE + "/session";
export const ARCHIVE_ROUTE = COMMUNICATION_ROUTE + "/archiveSessions";

export const FREQUENCY_ROUTE = CONTENT + "/frequency";
export const WAVES_ROUTE = FREQUENCY_ROUTE + "/waves";
export const WAVE_DETAIL_ROUTE = WAVES_ROUTE + "/category/:categoryId/wave/:id";
export const SOLFEGGIO_ROUTE = FREQUENCY_ROUTE + "/solfeggio";
export const CHAKRAS_ROUTE = FREQUENCY_ROUTE + "/chakras";

export const PURE_TONES_ROUTE = CONTENT + "/sal-magic/pure-tones";
export const OTHER_SOURCES_ROUTE = CONTENT + "/sal-magic/other-sources";

export const GATE_ROUTE = CONTENT + "/gate";
export const BALANCE_GATE_ROUTE = GATE_ROUTE + "/balancegate";
export const MANIFESTATION_GATE_ROUTE = GATE_ROUTE + "/transfigurationgate";

export const LEARN_ROUTE = CONTENT + "/learn";
export const TRAIN_ROUTE = CONTENT + "/train";
export const PLAYLISTS_ROUTE = CONTENT + "/playlists";
export const DESCRIPTION_ROUTE = CONTENT + "/description";

export const FAQ_ROUTE = CONTENT + "/faq";
export const SAL_MAGIC_FAQ_ROUTE = CONTENT + "/sal-magic/faq";
export const T_C_ROUTE = CONTENT + "/t&c";
export const PORTAL_ROUTE = "/portal";

export const REGISTER_ROUTE = "/register";
export const SUBSCRIPTION_ROUTE = "/subscription";
export const FREE_TRIAL_CALLBACK_ROUTE = "/subscription/free-trial/callback";
export const ASK_SALAH_SUBSCRIPTION_ROUTE = "/ask-salah-subscription";
export const BIOFLOW_SUBSCRIPTION_ROUTE = "/bioflow-subscription";
export const LOGIN_ROUTE = "/login";
export const LOGIN_SMARTSWAY_ROUTE = "/autologin";
export const LOGOUT_ROUTE = "/logout";
export const FORGET_ROUTE = "/forget";
export const FORGET_RESET_ROUTE = "/forget/reset";
export const EMAIL_VERIFICATION_ROUTE = "/verify";
export const PAYMENT_DONE_ROUTE = "/payment/success";

/** Paths where users are intentionally unauthenticated; session/401 handling must not force navigation to login. */
const authRecoveryPathnames: readonly string[] = [
  LOGIN_ROUTE,
  REGISTER_ROUTE,
  FORGET_ROUTE,
  FORGET_RESET_ROUTE,
  EMAIL_VERIFICATION_ROUTE,
];

export const isAuthRecoveryPathname = (pathname: string) =>
  authRecoveryPathnames.includes(pathname);

export const SETTINGS_ROUTE = "/settings";
export const PRELOADING_ROUTE = "/preloading";

export const LANDING_PAGE_ROUTE = "https://landing.sal125.smartsway.com/";
